var SEP = '|';
var PAIR = '=';

/*
 * the FingerPrint prototype object defines the following properties, deviceprint_browser,
 * deviceprint_display...., that reference the functions, deviceprint_browser,
 * deviceprint_display, .... Every instance of FingerPrint inherits the
 * prototype allowing them to call the FingerPrint functions through the
 * properties.
 */
class FingerPrint {
	deviceprint_version = function () {
		return 1;
	};

	/*
	 * This function captures the User Agent String from the Client Browser
	 */
	deviceprint_browser = function () {
		var userAgent = navigator.userAgent;
		var ua = userAgent.toLowerCase();
		var t = ua + SEP + navigator.appVersion + SEP + navigator.platform;
		return t;
	};

	/*
	 * This function captures the Client's Screen Information
	 */
	deviceprint_display = function () {
		var t = "";
		if (self.screen) {
			t += screen.colorDepth + SEP + screen.width + SEP + screen.height + SEP + screen.availHeight;
		}
		return t;
	};

	/*
	 * This function captures the user's timezone in GMT
	 */
	deviceprint_timezone = function () {
		var gmtHours = (new Date().getTimezoneOffset() / 60) * (-1);
		return gmtHours;
	};

	/*
	 * This function captures the user's browser language. Note: this is captured in
	 * the User Agent String, but this function provides more detailed information
	 * from IE (system language)
	 */
	deviceprint_language = function () {
		var lang;

		if (typeof (navigator.language) !== "undefined") {
			lang = "lang" + PAIR + navigator.language + SEP;
		} else {
			lang = "lang" + PAIR + "" + SEP;
		}

    lang += "syslang" + PAIR + "" + SEP;
		lang += "userlang" + PAIR + "";
		return lang;
	};

	/*
	 * This function captures whether or not user enabled cookies or not
	 */
	deviceprint_cookie = function () {

		var cookieEnabled = (navigator.cookieEnabled) ? 1 : 0;
		return cookieEnabled;
	};
}

/*
 * Deviceprint - delimited string value where names are in accordance with
 * PassMarkDeviceRequest
 */
export function add_deviceprint() {
  var fp = new FingerPrint();
	var t = "version=" + fp.deviceprint_version() + "&pm_fpua=" + fp.deviceprint_browser() + "&pm_fpsc=" + fp.deviceprint_display() + "&pm_fpsw=&pm_fptz=" + fp.deviceprint_timezone() + "&pm_fpln=" + fp.deviceprint_language() + "&pm_fpjv=0&pm_fpco=" + fp.deviceprint_cookie();
	return t;
}
